angular.module("smartorg.r6.navs.reportOptions").directive("optionHeader", [function () {
        return {
            restrict: "E",
            template: require('../../template/option-header.html'),
            transclude: true,
            scope: {},
            link: function (scope) {
                /**
                 * Default is true because the panel is collapsed on load.
                 *
                 * @type {boolean}
                 */
                scope.showHeader = true;
                /**
                 * Update the header display messages.
                 *
                 * @param options {{}} Including filters, group by, color
                 *     by, and compare to info.
                 */
                scope.updateHeader = function (options) {
                    var filters = options.filterLogic ?
                        options.filterLogic : undefined;
                    if (filters && filters.length > 50) {
                        filters = filters.substr(0, 50) + '...';
                    }
                    scope.optionHeader = {
                        filters: filters,
                        groupby: options.groupKey ?
                            options.groupKey : undefined,
                        colorby: options.colorKey ?
                            options.colorKey : undefined,
                        compareTo: options.compareToNodeName ?
                            options.compareToNodeName : undefined,
                        expandUnassignedForGroupBy: options.expandUnassignedForGroupBy
                    };
                };
                // Listen to report option events.
                scope.$on("report:header.update", function (event, args) {
                    if (args['data']) {
                        scope.updateHeader(args['data']);
                    }
                });
                scope.$on("report:header.toggle", function (event, args) {
                    scope.showHeader = args['show'] && args['show'] === true;
                });
            }
        };
    }]);
//# sourceMappingURL=option-header-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options/app/js/plumbing/option-header-directive.js